import { formatCurrency } from "@/utils"
import type { InvoiceAmountDueBreakdownTableProps } from "./InvoiceAmountDueBreakdownTable.types"

export interface InvoiceAmountDueBreakdownRow {
  key: string
  item: string
  amount: string
}

export const createInvoiceAmountDueBreakdownRows = ({
  invoice,
}: InvoiceAmountDueBreakdownTableProps): InvoiceAmountDueBreakdownRow[] => {
  const subtotalAmount = invoice.subtotalAmount ?? 0
  const discountAmount = invoice.discountAmount ?? 0
  const taxAmount = invoice.taxAmount ?? 0
  const totalAmount = invoice.totalAmount ?? 0
  const platformFeeAmount = invoice.platformFeeAmount ?? 0
  const stripeFeeAmount = invoice.stripeFeeAmount ?? 0
  const memberPaysTotal =
    invoice.memberPaysTotal ?? invoice.amountDue ?? totalAmount
  const amountDue = invoice.memberPaysTotal ?? invoice.amountDue ?? totalAmount

  return [
    {
      key: "subtotal",
      item: "Subtotal",
      amount: formatCurrency(subtotalAmount),
    },
    {
      key: "discounts",
      item: "Discounts",
      amount: `-${formatCurrency(discountAmount)}`,
    },
    { key: "tax", item: "Tax", amount: `+${formatCurrency(taxAmount)}` },
    {
      key: "invoice-total",
      item: "Invoice Total",
      amount: formatCurrency(totalAmount),
    },
    {
      key: "platform-fee",
      item: "Platform Fee",
      amount: `+${formatCurrency(platformFeeAmount)}`,
    },
    {
      key: "processor-fee",
      item: "Processor Fee",
      amount: `+${formatCurrency(stripeFeeAmount)}`,
    },
    {
      key: "member-total",
      item: "Member Total",
      amount: formatCurrency(memberPaysTotal),
    },
    {
      key: "amount-due",
      item: "Amount Due",
      amount: formatCurrency(amountDue),
    },
  ]
}
